import { render, staticRenderFns } from "./AgentNavShortcuts.vue?vue&type=template&id=470e9ca9&"
import script from "./AgentNavShortcuts.vue?vue&type=script&lang=js&"
export * from "./AgentNavShortcuts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports